// TODO move to cdk

export function copyTextToClipboard(text: string): boolean {
    let ret = false;
    let textarea: HTMLTextAreaElement;

    try {
        textarea = document.createElement('textarea');
        textarea.style.position = 'fixed';
        textarea.style.top = '0';
        textarea.style.left = '-10000px';
        textarea.style.opacity = '0';
        textarea.setAttribute('aria-hidden', 'true');
        textarea.value = text;
        textarea.readOnly = true;

        document.body.appendChild(textarea);

        const currentFocus = document.activeElement as HTMLElement;

        textarea.select();
        textarea.setSelectionRange(0, textarea.value.length);
        ret = document.execCommand('copy');

        currentFocus?.focus();
    } catch {
        // do nothing
    }

    textarea?.remove();

    return ret;
}
